import {useEffect, useState} from "react";
import {ModalWithHeader} from "../../ui/Modal";
import StepEmail from "./StepEmail";
import StepVerify from "./StepVerify";
import {EmailModalProps} from "../../types/types";
import {useIntl} from "react-intl";

export default function EmailModal({
                                       isOpen = false,
                                       width = 480,
                                       onClose,
                                       onBack,
                                       onLogin
                                   }: EmailModalProps) {
    const [step, setStep] = useState<"input" | "verify">("input")
    const [emailVal, setEmailVal] = useState('')
    const intl = useIntl()

    useEffect(() => {
        if (!isOpen) {
            setStep('input')
            setEmailVal('')
        }
    }, [isOpen])

    return <ModalWithHeader
        isOpen={isOpen}
        width={width}
        onClose={onClose}
        title={intl.formatMessage({
            id:"email"
        })}
        onBack={step == 'verify' ? () => setStep("input") : onBack}
    >
        {
            step === "input" ? <StepEmail email={emailVal} onContinue={(email) => {
                setEmailVal(email)
                setStep("verify")
            }}/> : <StepVerify email={emailVal} onSuccess={onLogin}/>}
    </ModalWithHeader>
}